import { crypto } from './base'
import { InterWoff2Sync } from './fonts'

export const withSyncFont = { ...crypto, fonts: [InterWoff2Sync] }
